import styled from 'styled-components'
import {
  Actions as BaseActions,
  DesktopTable as BaseDesktopTable,
  MobileCards as BaseMobileCards,
} from 'components/UserApprovalsTable/styled'

export const DesktopTable = styled(BaseDesktopTable)`
  .MuiPaper-root {
    background: transparent;
    color: ${({ theme }) => theme.palette.colors.text};
  }

  .MuiTableCell-root {
    border-color: ${({ theme }) => theme.palette.colors.borderSoft};
    color: ${({ theme }) => theme.palette.colors.text};
  }

  .MuiTableHead-root .MuiTableCell-root {
    background: ${({ theme }) => theme.palette.colors.surfaceElevatedStrong};
  }

  .MuiTableBody-root .MuiTableRow-root:nth-of-type(odd),
  .MuiTableBody-root .MuiTableRow-root:nth-of-type(even) {
    background: ${({ theme }) => theme.palette.colors.surfaceElevated};
  }

  @media (max-width: 900px) {
    display: none;
  }
`

export const MobileCards = styled(BaseMobileCards)`
  @media (max-width: 900px) {
    color: ${({ theme }) => theme.palette.colors.text};
    display: block;
    min-width: 0;
    overflow: hidden;

    > div,
    .MuiPaper-root {
      max-width: 100%;
      min-width: 0;
      width: 100%;
    }

    .MuiPaper-root {
      color: ${({ theme }) => theme.palette.colors.text} !important;
    }

    .MuiPaper-root > div {
      min-width: 0;
      white-space: normal;
    }

    .MuiPaper-root > div > * {
      max-width: 100%;
      min-width: 0;
      overflow-wrap: anywhere;
    }
  }
`

export const Actions = styled(BaseActions)`
  @media (max-width: 900px) {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    width: 100%;

    .MuiButton-root {
      width: 100% !important;
    }
  }
`

export const TrainingName = styled.strong`
  color: ${({ theme }) => theme.palette.colors.text};
  font-weight: 700;
`

export const RequirementBadge = styled.span`
  border: 1px solid ${({ complete, theme }) => complete
    ? theme.palette.success.main
    : theme.palette.warning.main};
  border-radius: 999px;
  color: ${({ complete, theme }) => complete
    ? theme.palette.success.main
    : theme.palette.warning.main};
  display: inline-flex;
  font-size: 12px;
  font-weight: 700;
  padding: 5px 10px;
`
